import { AppState } from "../store/AppState";
import { Entitlement } from "../model/entitlement/Entitlement";
import { OrganizationGroup } from "../model/OrganizationGroup";

function selectEntitlement(
  id: string,
  state: AppState
): Entitlement | undefined {
  return !!id && !!state.entitlements ? state.entitlements[id] : undefined;
}
function selectEntitlementGroups(
  id: string,
  state: AppState
): OrganizationGroup[] | undefined {
  return !!id && !!state.orgGroupEntitlementIds && !!state.orgGroups
    ? (Object.keys(state.orgGroupEntitlementIds)
        .filter(
          groupId =>
            state.orgGroupEntitlementIds &&
            state.orgGroupEntitlementIds[groupId] &&
            state.orgGroupEntitlementIds[groupId].includes(id)
        )
        .map(groupId =>
          state.orgGroups ? state.orgGroups[groupId] : undefined
        ) as OrganizationGroup[])
    : undefined;
}
function selectGroupEntitlements(
  id: string,
  state: AppState
): Entitlement[] | undefined {
  return !!id &&
    !!state.orgGroupEntitlementIds &&
    !!state.orgGroupEntitlementIds[id] &&
    !!state.entitlements
    ? (state.orgGroupEntitlementIds[id].map(entId =>
        state.entitlements ? state.entitlements[entId] : undefined
      ) as Entitlement[])
    : undefined;
}
function compareEntitlementsStates(next: AppState, prev: AppState): boolean {
  return next.entitlements === prev.entitlements;
}
function compareEntitlementGroupsStates(
  next: AppState,
  prev: AppState
): boolean {
  return (
    next.orgGroupEntitlementIds === prev.orgGroupEntitlementIds &&
    next.orgGroups === prev.orgGroups
  );
}
const EntitlementUtils = {
  selectEntitlement,
  selectEntitlementGroups,
  compareEntitlementsStates,
  compareEntitlementGroupsStates,
  selectGroupEntitlements
};
export default EntitlementUtils;
